import { z } from "zod";

import { BudgetSchema, DietaryRestrictionSchema, LanguageSchema } from "./generated";

// Common schemas that can be shared across models
export const BookingPreferencesSchema = z.object({
  budget: BudgetSchema,
  languages: z.array(LanguageSchema).min(1),
  dietaryRestrictions: z.array(DietaryRestrictionSchema),
  bringFriend: z.boolean().optional().default(false),
  friendInvitationId: z.string().optional()
});
export type BookingPreferences = z.infer<typeof BookingPreferencesSchema>;
